module.exports = __webpack_public_path__ + "img/emoji-hot-air-balloon@3x.6857002.png";